/**
 * Hostname-aware routing helpers for Gefion.
 *
 * The Shop lives on its own subdomain (shop.gefion-evolution.it) and must not
 * be reachable from the corporate homepage. In non-production hosts (preview
 * environment, localhost) the shop is still browsable at /shop/* for QA.
 */

// Production hosts. Keep in sync with the deployed DNS records.
const MAIN_PRODUCTION_HOSTS = ["gefion-evolution.it", "www.gefion-evolution.it"];
const SHOP_PRODUCTION_HOST = "shop.gefion-evolution.it";

export const currentHost = () =>
  (typeof window !== "undefined" && window.location.hostname) || "";

// True when the browser is on the shop subdomain (any environment).
export const isShopHost = () => {
  const h = currentHost();
  return h.startsWith("shop.") || h === SHOP_PRODUCTION_HOST;
};

// True only for the corporate production domain.
export const isMainProductionHost = () =>
  MAIN_PRODUCTION_HOSTS.includes(currentHost());

// Absolute URL to the shop subdomain (used for outbound redirects from the
// corporate site). In non-production environments we stay on the same origin.
export const shopUrl = (path = "/shop") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (isMainProductionHost()) return `https://${SHOP_PRODUCTION_HOST}${normalized}`;
  return normalized;
};
